
import React, { useEffect, useState, useRef } from 'react';
import "../Landing.css";
import { Link } from 'react-router';
import { SERVER_HOST } from '../settings';
import { Messages } from 'primereact/messages';
import { useMountEffect } from 'primereact/hooks';


const LandingPage = () => {

    const [latestBatch, setLatestBatch] = useState('');

    useEffect(() => {
        const url = `${SERVER_HOST}/latestBatches`;
        fetch(url).then(data => data.json()).then((data) => {
            setLatestBatch(new Date(data?.overall)?.toLocaleString());
        })
    })

    const msgs = useRef(null);

    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show({
                id: '1',
                sticky: true,
                severity: 'warn',
                summary: 'Keep us running',
                detail: <div>
                        We run georank.io ad-free for the community. <a style={{ color: 'black', textDecoration: 'underline'}} href="https://ko-fi.com/B0B51C1QX9" target='_blank'><strong>Support</strong></a> helps cover costs.<br />
                    </div>,
                closable: false
        });
        }
    }); 

    return (
    <div className="landing layout-dark">
        <h1 className="text-align-center">Ranking types</h1>
        <h3 class="text-align-center">Last ranking update: {latestBatch}</h3>
                <div className="card flex justify-content-center text-align-center" style={{width: '100%'}}>
                    <Messages ref={msgs} />
                </div>
        <p>
            &nbsp;
        </p>
        <section className="landing-hero px-5 lg:px-8">
            
            <div className="flex flex-col w-12 pl-3 grid">

                <Link to={'/countries'} className="box p-4 mb-4 lg:mb-0 fadein animation-duration-500 lg:col-offset-1 lg:col-5">
                    <div className="surface-card mb-4 w-full text-center p-5" style={{ borderRadius: '10px' }}>
                        <img src="../countriesRanking.png" alt="Sneaker"/>
                    </div>
                    <button className="w-full p-button p-component p-button-outlined">
                        <span className="p-button-icon p-c p-button-icon-left pi pi-trophy"></span>
                        <span className="p-button-label p-c">Explore countries ranking</span>
                        <span className="pi pi-arrow-right p-button-icon-right"></span>
                    </button>
                </Link>

                <Link to={'/players'} className="box p-4 fadein animation-duration-500 lg:col-offset-1 lg:col-5">
                    <div className="surface-card mb-4 w-full text-center p-5" style={{ borderRadius: '10px' }}>
                        <img src="https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/5e94c0ed87a86a53b6b3e1f25833d877.png" alt="Sneaker"/>
                    </div>
                    <button className="w-full p-button p-component p-button-outlined">
                        <span className="p-button-icon p-c p-button-icon-left pi pi-trophy"></span>
                        <span className="p-button-label p-c">Explore players ranking</span>
                        <span className="pi pi-arrow-right p-button-icon-right"></span>
                    </button>
                </Link>
                <p class="section-detail px-0 mt-0 p-5 text-align-center" style={{width: '100%'}}>
                    <strong>GeoRank.io</strong> tracks GeoGuessr's competetive rankings <i>every day</i>
                </p>
                <p class="section-detail px-0 mt-0 mb-5 text-align-center" style={{width: '100%'}}>
                    For GeoGuessr Team Duels Ranking → <a href="https://www.geoteamrank.com" target='_blank'>geoteamrank.com</a>
                </p>
            </div>
        </section>
      </div>
    );
  };
  
  export default LandingPage;